import React, { useEffect } from 'react'
import style from "./home.module.css"
import { Link } from 'react-router-dom'

export const Hero = ({ locked }) => {
    // function counter(id, start, end, duration) {
    //     let obj = document.getElementById(id),
    //         current = start,
    //         range = end - start,
 
    //         increment = end > start ? 1 : 0,
    //         step = Math.abs(Math.floor(duration / range)),
    //         timer = setInterval(() => {
    //             current += increment;
    //             obj.textContent = current;
    //             if (current == end) {
    //                 clearInterval(timer);
    //             }
    //         }, step);
    // }
    // useEffect(() => {
    //     counter("count1", 0, Math.floor(Number(locked)), 30000);
    //     console.warn(typeof Math.floor(Number(locked)))

    // }, [locked])

    // console.log("locked", locked);
    

    return (
        <section className={style.hero_container}>
            <div className={style.hero + ' container pt-sm-5 pt-3 d-flex flex-column flex-md-row flex-wrap flex-xl-nowrap justify-content-between'}>
                <div className={style.left + " mt-4"}>
                    <p className='mb-0 text-center text-md-start'>Welcome to the</p>
                    <h1 className='text-center text-md-start'><span>Strength</span> Of Shield</h1>
                </div>
                <div className={style.center + ' d-flex justify-content-center align-items-start'}>
                        <img src="/images/hero-logo.svg" className='' width="100%" alt="" />
                </div>
                <div className={style.right + " d-flex strok_anim_hover position-relative mt-4 flex-column justify-content-between align-items-center"}>
                    <span>Total Locked </span>
                    {/* <p id='count1'></p> */}
                    <p>{locked ? Number(locked).toFixed(0) : 0}</p>
                    <div className='d-flex w-100 gap-xl-3 gap-sm-5 justify-content-between gap-2'>
                        <Link to="/lock" className='w-50 text-decoration-none'>
                        <button className='btn1 w-100 py-3 px-xxl-5 px-xl-4 px-sm-5 px-3 text-nowrap h-100'>Lock Yours</button>
                        </Link>
                        <Link to="https://shield-pro.gitbook.io/shield" target='_blank' className='w-50 text-decoration-none'>
                        <button className='btn3 w-100 py-3 px-xxl-5 px-xl-4 px-sm-5 px-3 text-nowrap'>Learn More</button>
                        </Link>
                    </div>
                </div>
            </div>
        </section> 
    )
}
